import Header from "@/components/Header";
import Hero from "@/components/Hero";
import About from "@/components/About";
import Services from "@/components/Services";
import Fleet from "@/components/Fleet";
import WhyChooseUs from "@/components/WhyChooseUs";
import HowItWorks from "@/components/HowItWorks";
import BookingSection from "@/components/BookingSection";
import ServiceArea from "@/components/ServiceArea";
import Testimonials from "@/components/Testimonials";
import FAQ from "@/components/FAQ";
import ContactConsultation from "@/components/ContactConsultation";
import SeoHub from "@/components/SeoHub";
import Footer from "@/components/Footer";
import StickyCall from "@/components/StickyCall";
import Seo, { LOCAL_BUSINESS_SCHEMA } from "@/components/Seo";
import { FAQS } from "@/lib/data";

export default function Home() {
  const jsonLd = {
    "@context": "https://schema.org",
    "@graph": [
      { ...LOCAL_BUSINESS_SCHEMA, "@context": "https://schema.org" },
      {
        "@context": "https://schema.org",
        "@type": "WebSite",
        "@id": "https://comfortcarenemt.com/#website",
        url: "https://comfortcarenemt.com/",
        name: "Comfort Care Transportation",
        publisher: { "@id": "https://comfortcarenemt.com/#business" },
      },
      {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: FAQS.map((f) => ({
          "@type": "Question",
          name: f.q,
          acceptedAnswer: { "@type": "Answer", text: f.a },
        })),
      },
    ],
  };

  return (
    <div className="min-h-screen bg-white">
      <Seo
        title="Comfort Care Transportation | Wheelchair NEMT in Virginia, DC & Maryland | 571-689-4470"
        description="Safe, reliable, compassionate non-emergency medical transportation across Virginia, Washington DC, and Maryland. ADA-compliant wheelchair vans, dialysis & hospital discharge rides. Call 571-689-4470."
        path="/"
        image="https://customer-assets.emergentagent.com/job_comfort-care-booking/artifacts/l5bnk78a_2C3E0AE7-BC6B-41D5-8937-5C064B8E8692.PNG"
        keywords={[
          "non emergency medical transportation",
          "NEMT Virginia",
          "NEMT DC",
          "NEMT Maryland",
          "wheelchair transportation Virginia",
          "dialysis transportation",
          "hospital discharge transportation",
          "senior medical transportation",
          "Comfort Care Transportation",
          "wheelchair accessible van",
          "ADA compliant transportation",
          "medical ride near me",
        ]}
        jsonLd={jsonLd}
      />
      <Header />
      <main>
        <Hero />
        <About />
        <Services />
        <Fleet />
        <WhyChooseUs />
        <HowItWorks />
        <BookingSection />
        <ServiceArea />
        <Testimonials />
        <FAQ />
        <SeoHub />
        <ContactConsultation />
      </main>
      <Footer />
      <StickyCall />
    </div>
  );
}
